import type { RouteRecordRaw } from "vue-router"

export const StateLookupRoutes: RouteRecordRaw[] = [
  {
    path: "state-lookup",
    children: [
      {
        path: "",
        component: () => import("./StateLookupPage.vue"),
      },
    ],
  },
]
